export const frequencyTypes = [
    { "option": "Weekly", "label": "Weekly" },
    { "option": "Bi-weekly", "label": "Bi-weekly" },
    { "option": "Monthly", "label": "Monthly" },
    { "option": "Quarterly", "label": "Quarterly" },
    { "option": "Semi-annually", "label": "Semi-annually" },
    { "option": "Annualy", "label": "Annualy" },
]
